module.exports = __webpack_public_path__ + "static/media/柴公園.f60e09c1.jpg";